import React from "react";
import "../../styles/ServicePages.css";

const CustomPage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>📑 Customs Clearance Services</h1>
        <p>Expert customs documentation and compliance support for seamless international trade</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Navigate Customs with Expertise</h2>
          <p className="overview-text">
            AROCL provides comprehensive customs clearance services ensuring compliance with all regulations and expedited processing. 
            Our expert brokers handle documentation, classification, duty assessment, and inspections.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📋</span>
            <h3>Documentation & Filing</h3>
            <p>Complete customs documentation and filing for import/export operations</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔍</span>
            <h3>HS Code Classification</h3>
            <p>Accurate tariff classification minimizing duty and regulatory complications</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">💰</span>
            <h3>Duty Assessment</h3>
            <p>Transparent duty calculations and optimization strategies</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🏢</span>
            <h3>Bonded Warehousing</h3>
            <p>Secure bonded storage facilities for goods awaiting clearance</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">✅</span>
            <h3>Compliance Verification</h3>
            <p>Ensure adherence to all import/export regulations and requirements</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Expedited Clearance</h3>
            <p>Fast-track processing to minimize customs delays</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Customs Clearance Advantages</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Regulatory Compliance</h4>
                <p>Stay compliant with all import/export laws and regulations</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Faster Clearance</h4>
                <p>Professional handling reduces processing time and delays</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Cost Optimization</h4>
                <p>Smart classification strategies minimize duty payments</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Risk Mitigation</h4>
                <p>Avoid penalties and legal issues with expert compliance</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Customs Clearance Process</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Document Collection</h3>
              <p>Gather all shipping documents, invoices, and certificates</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Classification & Assessment</h3>
              <p>Classify goods with correct HS codes and calculate duties</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Declaration & Filing</h3>
              <p>Submit declarations and documentation to customs authorities</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Inspection & Release</h3>
              <p>Coordinate inspections and obtain goods release</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">1000+</div>
            <div className="stat-label">Clearances/Month</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">98%</div>
            <div className="stat-label">Approval Rate</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">48hrs</div>
            <div className="stat-label">Avg Processing</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">50+</div>
            <div className="stat-label">Expert Brokers</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Clear Customs Efficiently</h2>
          <p>Let AROCL handle your customs clearance for smooth international trade operations.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=I need help with customs clearance."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CustomPage; 

